import React from "react";
import ReactDOM from "react-dom";
import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import { cdpresseHomeTranslations } from "./locales/cdpresse_home_translations";
import { cdpresseRelayeurTranslations } from "./locales/cdpresse_relayeur_translations";


i18n
.use(initReactI18next) // passes i18n down to react-i18next
.init({
  resources: {
      fr: {
        translation: {
          Page_doesnt_exist_no_more: "La page que vous cherchez n'existe pas, a été transférée ou n'existe plus.",
          ...cdpresseHomeTranslations.fr,
          ...cdpresseRelayeurTranslations.fr,
        }
      },
      en: {
        translation: {
          Page_doesnt_exist_no_more: "The page you requested was not found.",
          ...cdpresseHomeTranslations.en,
          ...cdpresseRelayeurTranslations.en,
        }
      },
  },
  lng: "fr",
  fallbackLng: "fr",

  interpolation: {
    escapeValue: false
  }
});

export default i18n;
